import { Amount, asAmount } from "@goodfill/domain-properties";
import { Flex, Span, InputNumber } from "@goodfill/ui-components";
import Decimal from "decimal.js";
import { FormValidationResult } from "../../../../form/formValidation";
import { FormValidationComponent } from "../../../../form/FormValidationComponent";
import { InfoTooltip } from "../../../../ui-components/tooltip/InfoTooltip";
import "./CreateOrderFaceAmountInput.scss";

interface Props {
  validation: FormValidationResult;
  value: Amount;
  onChange: (value: Amount) => void;
  disabled: boolean;
  CheckboxDiv: React.ReactNode;
  state: string;
}

export const CreateOrderFaceAmountInput: React.FC<Props> = ({
  validation,
  value,
  onChange,
  disabled,
  CheckboxDiv,
  state,
}) => {
  const width = state !== "Immediate" ? 60 : 80;
  return (
    <Flex direction="row" className="px-8 face-amount-container">
      <Flex direction="col" justify="start">
        <Flex width={40} items="start" direction="col">
          <Span size="base" font="semibold" className="px-0-important">
            <InfoTooltip text="Face Amount of bond transaction." />
            Face Amount
          </Span>
        </Flex>
        <Flex direction="rowCol" gap={3} items="center">
          <Flex direction="row" gap={0} items="center">
            <InputNumber
              disabled={disabled}
              leftIcon={"$"}
              border={"neutral"}
              value={value.div(1000).toFixed(0)}
              setValue={(value) => {
                if (value !== null) {
                  onChange(asAmount(new Decimal(value).mul(1000)));
                }
              }}
              textAlign="left"
              width={width}
              placeholder="Enter Face Amount"
              className="face-amount-input"
              id="faceAmount"
            />
            <Span style={{ color: "rgba(51, 63, 81, 0.6)" }}>,000</Span>
          </Flex>
          {CheckboxDiv}
        </Flex>
        <FormValidationComponent validation={validation} />
      </Flex>
    </Flex>
  );
};
